import React from 'react';
import { Link } from 'react-router-dom';
import PortalLogo from '../../portal/PortalLogo';
import Modal from '../modal/Modal';
import Sidebar from '../sidebar/Sidebar';
import HeaderProfile from './HeaderProfile';

const Header = (props) => {
  const { onlyLogo } = props || {};

  return (
    <>
      <Modal />
      <Sidebar />

      <header className="hui-header position-fixed d-flex align-items-center hui-bg-white border-bottom">
        <div className="pe-4 hui-header-logo">
          {onlyLogo ? (
            <PortalLogo />
          ) : (
            <Link to="/dashboard">
              <PortalLogo />
            </Link>
          )}
        </div>
        {!onlyLogo && (
          <div className="flex-grow-1 d-flex align-items-center">
            <HeaderProfile />
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
